<template>
  <div
    class="offcanvas offcanvas-end"
    tabindex="-1"
    id="offcanvasRight"
    aria-labelledby="offcanvasRightLabel"
  >
    <div class="offcanvas-header position-fixed w-100">
      <h5 id="offcanvasRightLabel"></h5>
      <button
        type="button"
        class="btn-close text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>
    <div class="offcanvas-body d-flex flex-column justify-content-center">
      <div class="row w-100">
        <div
          class="col-md-6 col-sm-12 d-flex flex-column align-items-center text-center py-3"
        >
          <div class="col-6 pb-3">
            <img
              src="/img/ui-theme/dough-walsh.png"
              alt="Dough Walsh"
              class="rounded-circle img-fluid"
            />
          </div>
          <h4 class="text-black">Contact Dough Walsh</h4>
          <div class="d-flex justify-content-evenly w-75 py-2">
            <a href="mailto:doug@positionproperty.com.au">
              <img src="/img/ui-theme/email-icon-rev.svg" alt="Email" />
            </a>
            <a href="tel:0403 309 222" class="d-lg-none">
              <img src="/img/ui-theme/phone-icon-rev.svg" alt="Contact" />
            </a>
          </div>
          <a href="tel:0403 309 222" class="phone d-none d-lg-block">
            <h4>0403 309 222</h4>
          </a>
        </div>

        <div
          class="col-md-6 col-sm-12 d-flex flex-column align-items-center text-center py-3"
        >
          <div class="col-6 pb-3">
            <img
              src="/img/ui-theme/james-crozier.png"
              alt="James Crozier"
              class="rounded-circle img-fluid"
            />
          </div>
          <h4 class="text-black">Contact James Crozier</h4>
          <div class="d-flex justify-content-evenly w-75 py-2">
            <a href="mailto:James.crozier@positionproperty.com.au">
              <img src="/img/ui-theme/email-icon-rev.svg" alt="Email" />
            </a>
            <a href="tel:0468 571 238" class="d-lg-none">
              <img src="/img/ui-theme/phone-icon-rev.svg" alt="Contact" />
            </a>
          </div>
          <a href="tel:0468 571 238" class="phone d-none d-lg-block">
            <h4>0468 571 238</h4>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OffCanvas",
  props: ["heading"],
  data() {
    return {};
  },
};
</script>

<style scoped>
.btn-theme-menu {
  width: 60%;
  background: #000;
  color: #fff;
  font-weight: 300;
  margin: auto;
}
.phone {
  color: #000;
  text-decoration: none;
}
</style>
